import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddService } from '../../admin/add-edit/add.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ExamService } from '../exam.service';

@Component({
  selector: 'app-update-user-status',
  templateUrl: './update-user-status.component.html',
  styleUrls: ['./update-user-status.component.scss']
})
export class UpdateUserStatusComponent implements OnInit {

  updateUserForm: FormGroup;
  model : any;
  user:any;
  constructor(
    private dialog: Dialog,
    private fb: FormBuilder,
    private examService: ExamService,
    public dialogRef: DialogRef<UpdateUserStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.user = data.user;
    this.updateUserForm = this.fb.group({
      userStatus: [this.user.status, Validators.required]
    });

    this.model = data.model;
  }

  ngOnInit(): void {
  }

  updateUserStatus(){
    const body = {
      sessionId : this.user.sessionid,
      status : this.updateUserForm.controls['userStatus'].value
    };
    this.examService.updateUserStatus(body).subscribe((res:any)=>{
      this.dialogRef.close();
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
